import { render } from "./SolicitudInspeccionComponent.vue?vue&type=template&id=d484f1b8"
import script from "./SolicitudInspeccionComponent.vue?vue&type=script&lang=js"
export * from "./SolicitudInspeccionComponent.vue?vue&type=script&lang=js"

import "./SolicitudInspeccionComponent.vue?vue&type=style&index=0&id=d484f1b8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__